import React from 'react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import HomeSmall from 'wix-ui-icons-common/HomeSmall';
import { useIsMobile } from '../../customHooks/useIsMobile';
import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { ActiveLink } from '../ActiveLink/index';
import { Breadcrumbs } from '../Layout/Breadcrumbs/index';
import { CustomLink } from '../PageElements/CustomLink';
import { Text } from '../PageElements/Text';
import { StoreContext } from '../../appContext/StoreProvider/index';
import style from './CurrentLocationBreadcrumbs.scss';
import {
  generateBreadcrumbsObjectsFromNodeKey,
  getBreadcrumbsUrl,
  getHomePageUrl,
} from './utils';

export const CurrentLocationBreadcrumbs = () => {
  const { store } = React.useContext(StoreContext);
  const { isMobile } = useIsMobile();

  return (
    <ActiveLink>
      {({ activeLink }) => {
        const homePageUrl = getHomePageUrl(store);
        const breadcrumbsUrl = getBreadcrumbsUrl(
          store,
          activeLink,
          homePageUrl,
        );
        const onHomeIconClicked = () => {
          store.publishToFocusLocation(homePageUrl);
        };

        const items = generateBreadcrumbsObjectsFromNodeKey(
          breadcrumbsUrl,
          store.getFullTree(),
          store.viewer.viewerConfig.layoutType,
        );

        const shouldShowMobileItems = items.length > 2 && isMobile;
        const relevantItems = shouldShowMobileItems ? items.slice(-2) : items;
        const selectedRelatedSite = (
          store.viewer.viewerConfig.relatedSites || []
        ).find((relatedSite) => relatedSite?.active === true);
        const shouldShowHomeLinkInMobile = isMobile && items.length < 2;
        return (
          <ol
            className={style.breadcrumbsWrapper}
            data-hook="breadcrumbs-container"
            itemScope
            itemType="https://schema.org/BreadcrumbList"
          >
            {(shouldShowHomeLinkInMobile || !isMobile) && (
              <>
                <li
                  itemProp="itemListElement"
                  itemScope
                  itemType="https://schema.org/ListItem"
                >
                  <CustomLink
                    onClick={onHomeIconClicked}
                    to={{
                      pathname: '/',
                      state: { navType: NAV_TYPES.BREADCRUMBS },
                    }}
                    itemProp="item"
                    className={
                      !selectedRelatedSite ? style.homeIconContainer : ''
                    }
                  >
                    {!selectedRelatedSite ? (
                      <>
                        <HomeSmall
                          className={style.homeIcon}
                          data-hook="breadcrumb-home-icon"
                        />
                        <span itemProp="name" style={{ display: 'none' }}>
                          Home
                        </span>
                      </>
                    ) : (
                      <Text
                        dataHook="breadcrumb-related-site-home"
                        size="small"
                        weight="normal"
                        tagName="span"
                        secondary={true}
                        itemProp="name"
                      >
                        {selectedRelatedSite.name}
                      </Text>
                    )}
                  </CustomLink>
                  <meta itemProp="position" content="1" />
                </li>
                <ChevronRight className={style.homeIconSeprator} />
              </>
            )}

            <Breadcrumbs items={relevantItems} />
          </ol>
        );
      }}
    </ActiveLink>
  );
};
